// src/routes.js
import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdPerson,
  MdHome,
  MdLock,
  MdPermContactCalendar,
  MdCategory,
  MdListAlt,
  MdArticle,
  MdLabel,
  MdLanguage,
  MdForum,
  MdQuestionAnswer,
  MdDescription,
  MdLiveTv,
} from "react-icons/md";
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import users from "views/admin/Users";
import role from "views/admin/Role";
import category from "views/admin/Category";
import subCategory from "views/admin/SubCategory";
import news from "views/admin/News";
import tag from "views/admin/Tag";
import language from "views/admin/Language";
import botChannel from "views/admin/BotChannel";
import botResponse from "views/admin/BotResponse";
import botTemplate from "views/admin/BotTemplate";
import liveTV from "views/admin/LiveTV";
import SignInCentered from "views/auth/signIn";
import PAGE_IDS from "constants/pageIds";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "/Main Dashboard",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: MainDashboard,
    pageId: PAGE_IDS.MAIN_DASHBOARD,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "/profile",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Profile,
    pageId: PAGE_IDS.PROFILE,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "/users",
    icon: <Icon as={MdPermContactCalendar} width="20px" height="20px" color="inherit" />,
    component: users,
    pageId: PAGE_IDS.USERS,
  },
  {
    name: "Roles",
    layout: "/admin",
    path: "/roles",
    icon: <Icon as={MdPermContactCalendar} width="20px" height="20px" color="inherit" />,
    component: role,
    pageId: PAGE_IDS.ROLES,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "/category",
    icon: <Icon as={MdCategory} width="20px" height="20px" color="inherit" />,
    component: category,
    pageId: PAGE_IDS.CATEGORIES,
  },
  {
    name: "Sub Categories",
    layout: "/admin",
    path: "/sub-category",
    icon: <Icon as={MdListAlt} width="20px" height="20px" color="inherit" />,
    component: subCategory,
    pageId: PAGE_IDS.SUBCATEGORIES,
  },
  {
    name: "News",
    layout: "/admin",
    path: "/news",
    icon: <Icon as={MdArticle} width="20px" height="20px" color="inherit" />,
    component: news,
    pageId: PAGE_IDS.NEWS,
  },
  {
    name: "Tags",
    layout: "/admin",
    path: "/tags",
    icon: <Icon as={MdLabel} width="20px" height="20px" color="inherit" />,
    component: tag,
    pageId: PAGE_IDS.TAGS,
  },
  {
    name: "Languages",
    layout: "/admin",
    path: "/language",
    icon: <Icon as={MdLanguage} width="20px" height="20px" color="inherit" />,
    component: language,
    pageId: PAGE_IDS.LANGUAGES,
  },
  {
    name: "Bot Channels",
    layout: "/admin",
    path: "/bot/channels",
    icon: <Icon as={MdForum} width="20px" height="20px" color="inherit" />,
    component: botChannel,
    pageId: PAGE_IDS.BOT_CHANNELS,
  },
  {
    name: "Bot Responses",
    layout: "/admin",
    path: "/bot/responses",
    icon: <Icon as={MdQuestionAnswer} width="20px" height="20px" color="inherit" />,
    component: botResponse,
    pageId: PAGE_IDS.BOT_RESPONSES,
  },
  {
    name: "Bot Templates",
    layout: "/admin",
    path: "/bot/templates",
    icon: <Icon as={MdDescription} width="20px" height="20px" color="inherit" />,
    component: botTemplate,
    pageId: PAGE_IDS.BOT_TEMPLATES,
  },
  {
    name: "Live TV",
    layout: "/admin",
    path: "/live-tv",
    icon: <Icon as={MdLiveTv} width="20px" height="20px" color="inherit" />,
    component: liveTV,
    pageId: PAGE_IDS.LIVE_TV,
  }
];

export default routes;